import { Next } from '@securitize/ui-components';

export const GET_OPPORTUNITIES_NEXT = new Next('/opportunities', 'GET_OPPORTUNITIES_NEXT');
